(function () {
  "use strict";

  angular
    .module('trainerWebApp.directives')
    .directive('mfLoadingButton', mfLoadingButton);

  function mfLoadingButton() {

    return function ($scope, elem, attrs) {
      $scope.$watch(attrs.mfLoadingState, function (loadingState) {
        if (!loadingState || !elem[0]) return;

        if (loadingState.enabled)
          $(elem).button('reset');
        else
          $(elem).button('loading');

        elem[0].innerHTML = loadingState.text;
      });
    }
  }

})();
